import { css } from '@emotion/react'

export const baseStyles = ({ theme }) => css`
    position: relative;
    margin-bottom: ${theme.spacings.tera};

    ${theme.media.giga} {
      width: calc(100% + 24px);

      margin: 0 -${theme.spacings.kilo};
      margin-bottom: ${theme.spacings.tera};
    }

`
